import React from 'react';
import './dashboard-page.scss';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import {
  getPTZ, getResponseError, onlyNumbersOption, round,
} from '../../../utils/utils';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { errorNotification } from '../../Notifications/notificationDecorator';
import { setPTZ, updateCamera } from '../../Settings/actions';

export default function EditCameraPTZ(props) {
  const { camera = null, editZone = false, editPosition = false } = props;
  const intl = useIntl();
  const { formatMessage } = intl;
  const dispatch = useDispatch();
  const {
    register, getValues, watch, setValue,
  } = useForm({
    mode: 'onChange',
    defaultValues: getPTZ(camera.position),
  });

  const handleSave = () => {
    const values = getValues();
    dispatch(setPTZ({ values, id: camera.id }))
      .then(() => {
        dispatch(updateCamera({ ...camera, ...values }));
      })
      .catch(response => {
        errorNotification(formatMessage({ id: 'camera.save.ptz' }), getResponseError(response));
      });
  };

  React.useEffect(() => {
    const subscription = watch(handleSave);
    return () => subscription.unsubscribe();
  }, [watch]);

  const registerTransform = (name, max, min) => {
    const opt = register(name, { ...onlyNumbersOption, max, min });
    const { onChange, value, ...newProps } = opt;
    return {
      ...newProps,
      value,
      onChange: e => {
        const caretPos = e.currentTarget.selectionStart;
        const v = e.target.value;
        const len = v.length;
        if (Number.isNaN(Number(v)) || Number(v) < min) {
          e.target.value = Number(min).toFixed(3);
        } else if (Number(v) > max) {
          e.target.value = Number(max).toFixed(3);
        } else {
          e.target.value = Number(v).toFixed(3);
        }
        e.currentTarget.setSelectionRange(caretPos, caretPos);
        onChange(e);
      },
    };
  };

  if (!camera) return null;
  const handleInc = name => {
    let value = round(Number(getValues(name)) + 0.01);
    if (value > 1) {
      value = 1;
    }
    setValue(name, Number(value).toFixed(3));
  };
  const handleDec = name => {
    const min = name === 'zoom' ? 0 : -1;
    let value = round(Number(getValues(name)) - 0.01);
    if (value < min) {
      value = min;
    }
    setValue(name, Number(value).toFixed(3));
  };
  return (
    <>
      <div className="camera-inputs">
        <form>
          <TextInputWithLabel type="text" inputProps={registerTransform('tilt', 1, -1)} label={formatMessage({ id: 'camera.tilt' })} variant="material" />
          <TextInputWithLabel type="text" inputProps={registerTransform('pan', 1, -1)} label={formatMessage({ id: 'camera.pan' })} variant="material" />
          <TextInputWithLabel type="text" inputProps={registerTransform('zoom', 1, 0)} label={formatMessage({ id: 'camera.zoom' })} variant="material" />
        </form>
      </div>
      <div className="camera-position-controls">
        <div className="camera-position">
          <div className="position-button up-button" onClick={() => { handleInc('tilt'); }}><Icons customIcon icon="play-2" /></div>
          <div className="position-button right-button" onClick={() => { handleInc('pan'); }}><Icons customIcon icon="play-2" /></div>
          <div className="position-button bottom-button" onClick={() => { handleDec('tilt'); }}><Icons customIcon icon="play-2" /></div>
          <div className="position-button left-button" onClick={() => { handleDec('pan'); }}><Icons customIcon icon="play-2" /></div>
        </div>
        <div className="camera-zoom">
          <div className="zoom-button" onClick={() => { handleInc('zoom'); }}><Icons customIcon icon="plus" /></div>
          <div className="zoom-button" onClick={() => { handleDec('zoom'); }}><Icons customIcon icon="minus" /></div>
        </div>
      </div>
    </>

  );
}
